import { Controller } from "@hotwired/stimulus"

// Contrôleur pour gérer les onglets et les interactions du formulaire d'adhésion à l'organisation
export default class extends Controller {
  static targets = ["tab", "content"]

  connect() {
    // Vérifie si l'onglet de nouvel utilisateur est actif au chargement
    if (this.tabTargets.find(tab => tab.id === "new-user-tab").classList.contains("bg-blue-50")) {
      this.hideAllContent()
      this.showContent("new-user")
    }
  }

  // Gère le changement d'onglet
  switchTab(event) {
    const selectedTab = event.currentTarget
    const tabId = selectedTab.dataset.tab

    // Réinitialiser tous les onglets
    this.tabTargets.forEach(tab => {
      tab.classList.remove("bg-blue-50", "text-blue-600")
      tab.classList.add("text-gray-700")
    })

    // Activer l'onglet sélectionné
    selectedTab.classList.add("bg-blue-50", "text-blue-600")
    selectedTab.classList.remove("text-gray-700")

    // Afficher le contenu associé
    this.hideAllContent()
    this.showContent(tabId)

    // Réinitialiser les champs du formulaire
    if (tabId === "existing-user") {
      this.clearNewUserFields()
    } else if (tabId === "new-user") {
      this.clearExistingUserSelection()
    }
  }

  hideAllContent() {
    this.contentTargets.forEach(content => {
      content.classList.add("hidden")
    })
  }

  showContent(tabId) {
    const content = this.contentTargets.find(content => content.id === `${tabId}-content`)
    if (content) {
      content.classList.remove("hidden")
    }
  }

  clearNewUserFields() {
    // Réinitialiser les champs du nouvel utilisateur
    const emailField = this.element.querySelector('[name="organization_membership[user_email]"]')
    const passwordField = this.element.querySelector('[name="organization_membership[user_password]"]')
    const confirmationField = this.element.querySelector('[name="organization_membership[user_password_confirmation]"]')

    if (emailField) emailField.value = ''
    if (passwordField) passwordField.value = ''
    if (confirmationField) confirmationField.value = ''
  }

  clearExistingUserSelection() {
    // Réinitialiser la sélection d'utilisateur existant
    const userSelect = this.element.querySelector('[name="organization_membership[user_id]"]')
    if (userSelect) userSelect.selectedIndex = 0
  }
}
